webpackJsonp([1],{

/***/ 2132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_grv_services_index__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MapaEdicoesGrv',
  props: {
    grvId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      historico: null,
      loading: true,
      erro: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__domain_grv_services_index__["B" /* historicoAlteracoesGrv */])(this.grvId).then(function (response) {
      _this.historico = response.data;
      _this.loading = false;
    }).catch(function () {
      _this.erro = true;
      _this.loading = false;
    });
  }
});

/***/ }),

/***/ 2159:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2108)(true);
// imports


// module
exports.push([module.i, ".mapa-edicoes[data-v-d3e9c478]{padding:8px 4px;min-height:60px}.timeline-wrapper[data-v-d3e9c478]{padding:4px 0}.tl-entry[data-v-d3e9c478]{display:-ms-flexbox;display:flex;gap:12px;-ms-flex-align:start;align-items:flex-start}.tl-left[data-v-d3e9c478]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0;width:14px;padding-top:14px}.tl-dot[data-v-d3e9c478]{width:12px;height:12px;border-radius:50%;background:#158cba;-ms-flex-negative:0;flex-shrink:0}.tl-line[data-v-d3e9c478]{width:2px;-ms-flex:1;flex:1;background:#d9edf7;margin-top:4px;min-height:16px}.tl-card[data-v-d3e9c478]{-ms-flex:1;flex:1;margin-bottom:10px;border-left:3px solid #158cba!important}.tl-meta[data-v-d3e9c478]{font-size:12px}.tl-field-nome[data-v-d3e9c478]{font-size:12px;font-weight:600;color:#555;white-space:nowrap;width:160px}.tl-seta[data-v-d3e9c478]{font-size:12px;width:20px;text-align:center}.tl-val[data-v-d3e9c478]{font-size:11px;font-weight:400;max-width:200px;display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:middle}.table-condensed>tbody>tr>td[data-v-d3e9c478]{padding:3px 6px;vertical-align:middle}", "", {"version":3,"sources":["/opt/buildhome/repo/src/app/website/historico-alteracoes/components/MapaEdicoesGrv.vue"],"names":[],"mappings":"AACA,+BACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,mCACE,aAAe,CAChB,AACD,2BACE,oBAAqB,AACrB,aAAc,AACd,SAAU,AACV,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,0BACE,oBAAqB,AACrB,aAAc,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,sBAAuB,AACnB,mBAAoB,AACxB,oBAAqB,AACjB,cAAe,AACnB,WAAY,AACZ,gBAAkB,CACnB,AACD,yBACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,mBAAoB,AACpB,oBAAqB,AACjB,aAAe,CACpB,AACD,0BACE,UAAW,AACX,WAAY,AACR,OAAQ,AACZ,mBAAoB,AACpB,eAAgB,AAChB,eAAiB,CAClB,AACD,0BACE,WAAY,AACR,OAAQ,AACZ,mBAAoB,AACpB,uCAA0C,CAC3C,AACD,0BACE,cAAgB,CACjB,AACD,gCACE,eAAgB,AAChB,gBAAiB,AACjB,WAAY,AACZ,mBAAoB,AACpB,WAAa,CACd,AACD,0BACE,eAAgB,AAChB,WAAY,AACZ,iBAAmB,CACpB,AACD,yBACE,eAAgB,AAChB,gBAAoB,AACpB,gBAAiB,AACjB,qBAAsB,AACtB,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,qBAAuB,CACxB,AACD,8CACE,gBAAiB,AACjB,qBAAuB,CACxB","file":"MapaEdicoesGrv.vue","sourcesContent":["\n.mapa-edicoes[data-v-d3e9c478] {\n  padding: 8px 4px;\n  min-height: 60px;\n}\n.timeline-wrapper[data-v-d3e9c478] {\n  padding: 4px 0;\n}\n.tl-entry[data-v-d3e9c478] {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 12px;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n.tl-left[data-v-d3e9c478] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  width: 14px;\n  padding-top: 14px;\n}\n.tl-dot[data-v-d3e9c478] {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #158CBA;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n.tl-line[data-v-d3e9c478] {\n  width: 2px;\n  -ms-flex: 1;\n      flex: 1;\n  background: #d9edf7;\n  margin-top: 4px;\n  min-height: 16px;\n}\n.tl-card[data-v-d3e9c478] {\n  -ms-flex: 1;\n      flex: 1;\n  margin-bottom: 10px;\n  border-left: 3px solid #158CBA !important;\n}\n.tl-meta[data-v-d3e9c478] {\n  font-size: 12px;\n}\n.tl-field-nome[data-v-d3e9c478] {\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  white-space: nowrap;\n  width: 160px;\n}\n.tl-seta[data-v-d3e9c478] {\n  font-size: 12px;\n  width: 20px;\n  text-align: center;\n}\n.tl-val[data-v-d3e9c478] {\n  font-size: 11px;\n  font-weight: normal;\n  max-width: 200px;\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.table-condensed > tbody > tr > td[data-v-d3e9c478] {\n  padding: 3px 6px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2171:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2159);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2109)("20ec3ff3", content, true, {});

/***/ }),

/***/ 2201:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapa-edicoes"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "text-center text-muted m-t m-b"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin m-r-xs"
  }), _vm._v(" Carregando edições...\n  ")]) : (_vm.erro) ? _c('div', {
    staticClass: "text-center text-muted m-t m-b"
  }, [_vm._v("\n    Não foi possível carregar o histórico.\n  ")]) : (_vm.historico && _vm.historico.length === 0) ? _c('div', {
    staticClass: "text-center text-muted m-t m-b"
  }, [_vm._v("\n    Nenhuma edição de cadastro registrada para esta GRV.\n  ")]) : (_vm.historico) ? _c('div', {
    staticClass: "timeline-wrapper"
  }, _vm._l((_vm.historico), function(entry, idx) {
    return _c('div', {
      key: entry.id,
      staticClass: "tl-entry"
    }, [_c('div', {
      staticClass: "tl-left"
    }, [_c('div', {
      staticClass: "tl-dot"
    }), _vm._v(" "), (idx < _vm.historico.length - 1) ? _c('div', {
      staticClass: "tl-line"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "panel panel-default tl-card"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "tl-meta m-b-xs"
    }, [_c('strong', {
      staticClass: "text-primary"
    }, [_c('i', {
      staticClass: "fa fa-user-o m-r-xs"
    }), _vm._v(_vm._s(entry.username) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted m-l-sm"
    }, [_c('i', {
      staticClass: "fa fa-clock-o m-r-xs"
    }), _vm._v(_vm._s(entry.data) + "\n            ")])]), _vm._v(" "), _c('table', {
      staticClass: "table table-condensed table-striped m-n"
    }, [_c('tbody', _vm._l((entry.alteracoes), function(alt) {
      return _c('tr', {
        key: alt.campo
      }, [_c('td', {
        staticClass: "tl-field-nome"
      }, [_vm._v(_vm._s(alt.campo))]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "label label-danger tl-val"
      }, [_vm._v(_vm._s(alt.de))])]), _vm._v(" "), _c('td', {
        staticClass: "tl-seta text-muted"
      }, [_vm._v("→")]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "label label-success tl-val"
      }, [_vm._v(_vm._s(alt.para))])])])
    }), 0)])])])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2171)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(2132),
  /* template */
  __webpack_require__(2201),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d3e9c478",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/1.e7633e3bb906e9f91921.js